var Library = {
	node :null,
	current: null,

	init: function() {
		Library.bootstrap();
	},

	bootstrap: function() {
//		Quiz.node = $("<div id='quiz' class='quiz-main'><qwin></qwin></div>");
		Library.node = $("<div id='library' class='lib-main'><libcmp ref='lib'></libcmp></div>");

		$("#panels").append(Library.node);

		Vue.component('libcmp', Library.cmp);

		Library.vue = new Vue({
			el: '#library'
		});

	},

	open: function(id) {
		Library.vue.$refs.lib.open(id);
	},

	openFromFile: function(id) {
		Library.vue.$refs.lib.openFromFile(id);
	},

	placeReady: function(pe) {
	},

	process: function() {
	},

	ssi: function(className, method, params, fun) {
			
		var request = {};
						
		request.className = className;
		request.methodName = method;
						
		for(var propertyName in params) {
			request["parameters!" + propertyName] = params[propertyName];
		}
											
		$.ajax({						
			type: "POST",
			url: "https://www.wkraj.pl/gatewayManager.php?result=json",
			dataType: "json",
			data: request
		}).done(function( resp ) {
			fun(resp);
		});
	}

}

PluginManager.add(Library);